<template>

  <!-- Icon Text Tile Element -->
  <div
    class="icon-text-tile-element">

    <page-block
      v-if="hasContent"
      overlay-class="q-pa-lg"
      :bg-color="value.bgColor"
      :text-align="value.textAlign"
      :text-color="value.textColor"
      class="icon-text-tile-element__block"
      wrapper-class="icon-text-tile-element__wrapper">

      <!-- Title -->
      <h3
        class="icon-text-tile-element__title">
        {{ value.title.ru }}
      </h3>

      <!-- File -->
      <file-background
        v-if="value.file"
        :value="value.file"
        :video-ratio="16/12.5"
        class="icon-text-tile-element__file"/>

      <!-- Body -->
      <div
        v-html="value.body.ru"
        class="icon-text-tile-element__body fr-view"/>

      <!-- Buttons -->
      <page-block-buttons
        :value="value.buttons"
        class="icon-text-tile-element__buttons"/>

    </page-block>

  </div>

</template>

<script>

  import PageBlock from '@src/components/page/page-block';
  import PageBlockMixin from '@src/mixins/page-block-mixin';
  import FileBackground from '@src/components/file/file-background';
  import PageBlockButtons from '@src/components/page/page-block-buttons';

  export default {
    name: 'icon-text-tile-element',
    mixins: [
      PageBlockMixin,
    ],
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
    components: {
      PageBlock,
      FileBackground,
      PageBlockButtons,
    },
  };

</script>

<style lang="scss">

  .icon-text-tile-element {
    padding: $spacer-mm;

    &__block {
      height: 100%;
    }

    &__file {
      height: 7rem;
      margin-bottom: $spacer-mm;
    }

    &__file.video {
      height: 7rem;
      width: 10rem;
      overflow: hidden;
      border-radius: 8px;
    }

    &__title {
      font-weight: 600;
    }

    &__wrapper > * {
      margin-bottom: 0;
    }

    &__wrapper > *:not(:first-child) {
      margin-top: $spacer-mm;
    }
  }

</style>
